import { render, staticRenderFns } from "./TablePemesanan.vue?vue&type=template&id=0401d1d6"
import script from "./TablePemesanan.vue?vue&type=script&lang=js"
export * from "./TablePemesanan.vue?vue&type=script&lang=js"
import style0 from "./TablePemesanan.vue?vue&type=style&index=0&id=0401d1d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports